import Login from '../views/Login';
import ResetPassword from '../views/ResetPassword.vue';
import Layout from '../views/Layout';
import Home from '../views/Home';
import odemeTalep from '@/modules/odemeTalep';
import odemeTalepFormu from '@/modules/odemeTalepFormu';
import satinAlmaOdemeTalep from '@/modules/satinAlmaOdemeTalep';
import malzemeOnay from '@/modules/malzemeOnay';
import personelIzin from '@/modules/personelIzin';
import personelTalepOnay from '@/modules/personelTalepOnay';
import adayTespitOnay from '@/modules/adayTespitOnay';
import personelSevkOnay from '@/modules/personelSevkOnay';
import rapor from '@/modules/rapor';
import kullanicilar from '@/modules/kullanicilar';
import kysFormu from '@/modules/kysFormu';
import kycFormu from '@/modules/kycFormu';
import kyeFormu from '@/modules/kyeFormu';

export default [
  {
    path: '/',
    name: 'layout',
    component: Layout,
    meta: { auth: true },
    children: [
      {
        path: '/',
        name: 'home',
        component: Home,
      },
      {
        path: '/odemeTalep',
        name: 'odemeTalep',
        component: odemeTalep,
      },
      {
        path: '/odemeTalepFormu',
        name: 'odemeTalepFormu',
        component: odemeTalepFormu,
      },
      {
        path: '/satinAlmaOdemeTalep',
        name: 'satinAlmaOdemeTalep',
        component: satinAlmaOdemeTalep,
      },
      {
        path: '/malzemeOnay',
        name: 'malzemeOnay',
        component: malzemeOnay,
      },
      {
        path: '/personelIzin',
        name: 'personelIzin',
        component: personelIzin,
      },
      {
        path: '/personelTalepOnay',
        name: 'personelTalepOnay',
        component: personelTalepOnay,
      },
      {
        path: '/adayTespitOnay',
        name: 'adayTespitOnay',
        component: adayTespitOnay,
      },
      {
        path: '/personelSevkOnay',
        name: 'personelSevkOnay',
        component: personelSevkOnay,
      },
      {
        path: '/rapor',
        name: 'Rapor',
        component: rapor,
      },
      {
        path: '/kullanicilar',
        name: 'kullanicilar',
        component: kullanicilar,
      },
      {
        path: '/kysFormu',
        name: 'KysFormu',
        component: kysFormu,
      },
      {
        path: '/kycFormu',
        name: 'KycFormu',
        component: kycFormu,
      },
      {
        path: '/kyeFormu',
        name: 'KyeFormu',
        component: kyeFormu,
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    component: ResetPassword,
  },
];
